<template lang="pug">
  form.modal-card(v-on:submit.prevent="submitForm()")
    header.modal-card-head
      p.modal-card-title Esqueceu sua senha?
    section.modal-card-body
      p Digite seu email no campo abaixo para recuperar sua senha. Você receberá no seu email um link para alterar sua senha.
      hr
      b-field(label="Email*" v-bind:message="errors.first('email')" v-bind:type="isDanger('email')")
        b-input(type="email" v-model="userEmail" v-validate="validations.email" name="email")
      b-field.has-text-centered
    footer.modal-card-foot
      button.button.is-primary(v-bind:disabled="formInvalid" type="submit") Enviar
      a.button.is-danger.is-outlined(@click="$parent.close()") Fechar
</template>

<script>
  import AuthService from '@/services/auth.js'

  export default {
    name: 'forgotPasswordModal',
    data () {
      return {
        userEmail: '',
        validations: {email: {rules: {required: true, email: true, min: 5, max: 80, existing_email: true}}}
      }
    },
    methods: {
      isDanger (fieldName) {
        if (this.$validator.errors.has(fieldName)) return 'is-danger'
      },
      submitForm () {
        const loadingComponent = this.$loading.open()
        AuthService.resetPassword(this.userEmail)
        .then(response => {
          this.$snackbar.open({
            message: 'Email enviado com sucesso!',
            position: 'is-top'
          })
          loadingComponent.close()
          this.$parent.close()
        }, response => {
          loadingComponent.close()
          this.$snackbar.open({
            message: 'Erro ao redefinir a senha!',
            type: 'is-danger',
            actionText: 'Ver Erro',
            onAction: () => {
              this.$modal.open({content: `<pre>${JSON.stringify(response.body)}</pre>`})
            },
            position: 'is-top'
          })
        })
      }
    },
    computed: {
      formInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid || !this.fields[key].validated)
      }
    }
  }
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// ForgotPasswordModal.vue?34247c4c